import * as React from 'react';
import { UserLicenseType } from '@bb/users';
import AdminTile from '@app/react-common/AdminTile';
import { theme } from 'components';

class MergeListingOptions extends React.Component<any, never> {
  render() {
    const {
      $rootScope: { auth, hasFeature },
      $window,
    } = this.props;

    if (
      auth &&
      auth.roles[auth.role] < auth.roles.TEAM_ADMIN &&
      !(auth.licenseType === UserLicenseType.LICENSED && !auth.isUnverified)
    ) {
      $window.location.replace('#/feature-missing');
    }

    return (
      <div>
        <div className="normalheader transition animated fadeIn">
          <div className="hpanel">
            <div className="panel-body">
              <h2 className="font-light">Merge / Combine Listings</h2>
            </div>
          </div>
        </div>
        <div className="content animate-panel">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-body">
                  <div className="row">
                    <div className="col-md-5">
                      <div style={{ padding: '1.5em 1.5em 0' }}>
                        <h4>Merge Listings</h4>
                        <hr style={{ margin: 0 }} />
                      </div>
                      <AdminTile
                        url="#/listing/merge"
                        icon="fa fa-compress"
                        lines={['Merge', 'Listings']}
                      />
                      <div style={{ padding: '0 1.5em', color: theme.gray8 }}>
                        <h5>Hint:</h5>
                        <p>
                          Merging is best used for transferring information
                          between two listings.
                        </p>
                        <h5>Example 1:</h5>
                        MLS Relist
                        <h5>Example 2:</h5>
                        Exclusive listing to MLS
                      </div>
                    </div>
                    <div className="col-md-5 col-md-offset-1">
                      <div style={{ padding: '1.5em 1.5em 0' }}>
                        <h4>Combine Listings</h4>
                        <hr style={{ margin: 0 }} />
                      </div>
                      <AdminTile
                        url="#/listing/merge?combine"
                        icon="fa fa-columns"
                        lines={['Combine', 'Listings']}
                      />
                      <div style={{ padding: '0 1.5em', color: theme.gray8 }}>
                        <h5>Hint:</h5>
                        <p>
                          Combining is best used when there are 2 separate
                          listings that you want to convert into 1 single
                          listing (with multiple MLS numbers).
                        </p>
                        <h5>Example 1:</h5>
                        Same property listed on multiple boards.
                        <h5>Example 2:</h5>
                        Same property, listed twice as Commercial and
                        Residential.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MergeListingOptions;
